<div class="scroll-wrapper" #scrollWrapper>
    <div class="scroll-view">
        <ng-content></ng-content>
    </div>
</div>
